import { FC, ReactElement } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { tokens } from "@/tokens";

interface IPageHeader {
  title: string | JSX.Element;
  rightNode?: JSX.Element;
  count?: string | number;
}

const PageHeader: FC<IPageHeader> = ({
  title,
  rightNode,
  count,
}): ReactElement => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        mb: { xs: 2, lg: 3 },
      }}
    >
      <Typography fontWeight={tokens.fontWeight.semibold} variant="h5" flex={1} color={"#020202"}>
        {title}
        {count ? (
          <Box component="span" sx={{ color: "#AEB3B3", pl: 0.5 }}>
            ({count})
          </Box>
        ) : (
          ""
        )}
      </Typography>
      {rightNode}
    </Stack>
  );
};

export default PageHeader;
